import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const DYNAMIC_CONFIG_ITEMS = gql`
  query DynamicConfigItems(
    $filter: DynamicConfigItemsFilter
    $sort: DynamicConfigItemsSort
  ) {
    dynamicConfigItems(filter: $filter, sort: $sort) {
      count
      data {
        configSubtype
        configType
        createdAt
        description
        id
        isActive
        itemKey
        updatedAt
        value
      }
    }
  }
`;

export const PINCODE_DELIVERY_SCHEDULES = gql`
  query PincodeDeliverySchedules(
    $filter: PincodeDeliverySchedulesFilter
    $sort: PincodeDeliverySchedulesSort
  ) {
    pincodeDeliverySchedules(filter: $filter, sort: $sort) {
      count
      data {
        id
        pincodeId
        config
        isActive
        createdAt
        pincode {
          id
          pincode
          areaName
          library {
            id
            name
            libraryNumber
            city
            state
            pincode
            isActive
            isMasterLibrary
          }
        }
      }
    }
  }
`;

export const PINCODE_DELIVERY_SCHEDULE = gql`
  query PincodeDeliverySchedule($where: PincodeDeliveryScheduleUniqueInput!) {
    pincodeDeliverySchedule(where: $where) {
      message
      data {
        id
        pincodeId
        pincode {
          id
          pincode
          areaName
        }
        isActive
        config
        createdBy
        createdAt
        updatedAt
      }
    }
  }
`;

export const TOY_RESERVATION_RULES = gql`
  query ToyReservationRules($filter: ToyReservationRuleFilter) {
    toyReservationRules(filter: $filter) {
      count
      data {
        id
        name
        type
        config
        isActive
        createdBy
        createdAt
        updatedAt
        attachmentCount
      }
    }
  }
`;

/** Minimal user lookup used to render already saved SPECIFIC_USER rule selections. */
export const TOY_RESERVATION_RULE_USER = gql`
  query User($where: UserUniqueInput!) {
    user(where: $where) {
      id
      firstName
      lastName
      contactNo
      userNumber
    }
  }
`;
